import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Location} from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent implements OnInit {
  attachments:AttachmentItem[] = [];
  @Input() title: string = "Attachments";
  @Input() accept: string = ".pdf,docx,.doc,.image/*";
  @Output() attachmentList = new EventEmitter<AttachmentItem[]>()

  constructor(
    private location: Location,
    private settingsService: SettingsService,
  ){

  }

  ngOnInit() {
  }

  removeAttachment(index){
    this.attachments.splice(index, 1);
    this.attachmentList.emit(this.attachments)
  }

  onFileSelected(event) {
    let  file = event.target.files[0] as File;
    let  base64 = null;
    let fileSize = 'File Size : ' + parseFloat((file.size / 1000000).toFixed(5)) + 'MB';

    const reader = new FileReader();
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        base64 = reader.result.toString().split(',')[1];
        base64 = this.settingsService.b64toBlob(reader.result.toString().split(',')[1], 'application/pdf');

        this.attachments.push({
          filename: file.name,
          data: reader.result.toString().split(',')[1],
        });

        this.attachmentList.emit(this.attachments)
      };

    };
  }


  selectFile(event){
    var fileUploadedName = "";
    const file = event.target.files[0] as File;
    const fileUploadedNameData = file.name;
    if (fileUploadedNameData.length > 15) {
      fileUploadedName =  fileUploadedNameData.slice(0, 15) + '...';
    } else {
      fileUploadedName = fileUploadedNameData;
    }
    const fileReader: FileReader = new FileReader();
    const self = this;
    fileReader.onloadend = (x) => {
      this.attachments.push({"filename": fileUploadedName, "data": fileReader.result});
      console.log(this.attachments);
      this.attachmentList.emit(this.attachments)
    };

    fileReader.readAsDataURL(file);
}

}


export interface AttachmentItem {
  filename?:string;
  data?:string | ArrayBuffer;
}
